/**
 * "The user has pressed Stop; ignore whatever the engine says until it
 * actually stops."
 *
 * Stopping is not instant: the files already in flight finish or abort, and
 * the engine keeps emitting progress the whole time. Every surface that
 * renders that stream has to hold still, or one click produces a sequence of
 * contradictory frames — the Cloud Backup hero flicking to the next file and
 * back, and the app-wide toast vanishing, reappearing and vanishing again.
 *
 * Shared rather than per-component precisely because the toast and the hero
 * read the SAME event stream: latching only one of them just moves the flicker
 * to the other surface.
 *
 * Cleared by the engine's terminal event ('done' / 'stopped') or by an
 * explicit Resume — never on a timer, so a slow wind-down can't un-latch early.
 */
let _latched = false;
const _listeners = new Set();

function emit() {
    for (const fn of _listeners) fn(_latched);
}

/** The user pressed Stop / Snooze. */
export function latchBackupStop() {
    if (_latched) return;
    _latched = true;
    emit();
}

/** The engine reached a terminal state, or the user pressed Resume. */
export function clearBackupStopLatch() {
    if (!_latched) return;
    _latched = false;
    emit();
}

export function isBackupStopLatched() {
    return _latched;
}

export function subscribeBackupStopLatch(fn) {
    _listeners.add(fn);
    return () => { _listeners.delete(fn); };
}

/** Test seam. */
export function _resetBackupStopLatch() {
    _latched = false;
    _listeners.clear();
}
